import { baseApi } from './baseApi';

export const marketDataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllMarketAssets: builder.query({
      query: () => '/market-data',
      providesTags: ['MarketAssets'],
    }),
    getMarketAssetById: builder.query({
      query: (id) => `/market-data/${id}`,
      providesTags: (result, error, id) => [{ type: 'MarketAsset', id }],
    }),
    getMarketAssetHistory: builder.query({
      query: ({ marketAssetId, range = "1m" }) =>
        `/market-data/${marketAssetId}/history?range=${encodeURIComponent(range)}`,
      providesTags: (result, error, { marketAssetId }) => [{ type: 'MarketAssetHistory', id: marketAssetId }],
    }),
    getMarketAssetBySymbol: builder.query({
      query: (symbol) => `/market-data/symbol/${symbol}`,
      providesTags: (result, error, symbol) => [{ type: 'MarketAsset', id: symbol }],
    }),
    refreshMarketData: builder.mutation({
      query: (marketAssetId) => ({
        url: `/market-data/${marketAssetId}/refresh`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, marketAssetId) => [
        { type: 'MarketAsset', id: marketAssetId },
        'MarketAssets',
      ],
    }),
  }),
  overrideExisting: false,
});
